import React from 'react'
import clsx from 'clsx'

import { Text } from '@wartek-id/text-v1'
import { Button } from '@wartek-id/button-v1'
import { Shimmer } from '@wartek-id/shimmer'

import { assetUrl } from 'utils/url'
import { useKemudahanSurveyDialog } from 'app/KinerjaShared/hooks/use-kemudahan-survey-dialog'
import { useAuth } from 'utils/auth'
import { useAPIKinerja } from 'api/kinerja/useAPIKinerja'
import { useKemudahanSurveyTrackEvent } from 'app/KinerjaShared/hooks/use-kemudahan-survey-track-event'

type PerencanaanKemudahanSurveyCardProps = {
  className?: string
}

export function PerencanaanKemudahanSurveyCard({
  className,
}: PerencanaanKemudahanSurveyCardProps) {
  // -----------------------------------------
  // Get Perencanaan Data
  // -----------------------------------------
  const { data: perencanaanData, isLoading: isPerencanaanLoading } =
    useAPIKinerja(
      {
        staleTime: 60 * 60 * 1000, // 1 hour
      },
      {
        tipe: 'SPNF',
      }
    )
  const isPerencanaanDone = perencanaanData?.data?.status === 'READY'

  // -------------------------
  // Handle Kemudahan Survey
  // -------------------------
  const { session } = useAuth()
  const ptkId = session?.user?.ptkId

  const {
    isEnabled: isSurveyEnabled,
    isSubmitted: isSurveySubmitted,
    markAsSubmitted: markAsSubmittedSurvey,
  } = useKemudahanSurveyDialog({
    type: 'perencanaan-pamong',
    additionalKey: ptkId,
  })

  const { trackEvent: trackSurveyEvent } = useKemudahanSurveyTrackEvent()

  const handleClickSurvey = () => {
    trackSurveyEvent({
      actor: 'pamong',
      eventAction: 'view_gform',
      eventCategory: 'survey_kemudahan_perencanaan',
    })
    markAsSubmittedSurvey()
  }

  // -------------------------
  // Resolve visibility
  // -------------------------
  const shouldShow = isSurveyEnabled && !isSurveySubmitted && isPerencanaanDone

  if (isPerencanaanLoading) {
    return <Shimmer className={clsx('min-w-80', className)} height={160} />
  }

  if (!shouldShow) {
    return null
  }

  return (
    <section
      className={clsx(
        'p-6 bg-white rounded-lg shadow-card space-y-4',
        className
      )}
    >
      <div className="flex gap-4 items-start">
        <img
          src={assetUrl('/illustrations/img-term-condition-TnC-list.png')}
          className="w-16 h-16 flex-shrink-0"
          alt=""
        />
        <Text variant="body-sm">
          Ada saran dan masukan untuk tahap <strong>Perencanaan</strong>?
          Ceritakan ke kami melalui survei.
        </Text>
      </div>

      <Button
        as="a"
        href="https://forms.gle/zmpP9W6Xe3YBRqN58"
        target="_blank"
        rel="noopener noreferrer"
        size="lg"
        color="white"
        fullWidth
        onClick={handleClickSurvey}
      >
        Isi Survei Perencanaan
      </Button>
    </section>
  )
}
